import { render, staticRenderFns } from "./LinkCellTemplateRentSvc.vue?vue&type=template&id=2c9b24a8&scoped=true&"
import script from "./LinkCellTemplateRentSvc.vue?vue&type=script&lang=js&"
export * from "./LinkCellTemplateRentSvc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b24a8",
  null
  
)

export default component.exports